import { defineStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  textStyle: 'b4',
  fontSize: { mobile: '16px', laptop: '18px' },
  fontFamily: 'var(--font-inter)',
  color: '#0E151C',
  w: 'full',
  h: 'full',
  resize: 'none',
  p: '0',
  focusBorderColor: '#FFFAEA',
  _focus: { caretColor: '#00BE85' },
  _placeholder: {
    textStyle: 'b4',
    fontSize: { mobile: '13px', mg: '16px', laptop: '18px' },
    color: '#6E6E6E',
  },
};

export const Textarea = defineStyleConfig({ baseStyle });
